module.exports = __webpack_public_path__ + "static/media/lecroy.a02ac66a.png";